export const AdSizes = {
  BANNER: 50,
  FULL_BANNER: 60,
  LARGE_BANNER: 100,
  LEADERBOARD: 90,
  MEDIUM_RECTANGLE: 250,
  ANCHORED_ADAPTIVE_BANNER: undefined,
  INLINE_ADAPTIVE_BANNER: undefined,
  WIDE_SKYSCRAPER: 600,
  '400x300': 300,
  '480x260': 260,
};

export const SupportedClientAdSizes = [
  'MEDIUM_RECTANGLE',
  'LARGE_BANNER',
  'ANCHORED_ADAPTIVE_BANNER',
  'BANNER',
];
